// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2kxrj","productName":"Table_productName__2iDcZ"};